import { BellOutlined, CaretDownOutlined, CloudOutlined, FullscreenOutlined, HomeOutlined, LogoutOutlined, MessageOutlined, UserOutlined } from '@ant-design/icons';
import { Avatar, Badge, Button, Dropdown, Space } from 'antd';
import Text from 'antd/es/typography/Text';
import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import useAuthStore from '../../store/authStore';
import { providerMenu } from '../Menus/ProviderMenu';

function VendorHeader() {
    const { user, logout } = useAuthStore();
    const navigate = useNavigate();
    const location = useLocation();
    const [date, setDate] = useState(new Date());
    let [fullscreen, setFullscreen] = useState(false);

    useEffect(() => {
        const timer = setInterval(() => setDate(new Date()), 60000);
        return () => clearInterval(timer);
    }, []);

    const handleLogout = async () => {
        await logout();
        navigate('/auth/login');
    };

    const activeLabel = providerMenu.find((item) => item.key === location.pathname)?.label || '';

    const userDropdown = [
        {
            key: 'logout',
            icon: <LogoutOutlined />,
            label: 'Chiqish',
            danger: true,
            onClick: handleLogout,
        },
    ];


    return (
        <div
            style={{
                background: '#26272B',
                padding: '0 20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                boxShadow: '0 1px 6px rgba(0,0,0,0.07)',
                height: 56,
                lineHeight: '56px',
                position: 'sticky',
                top: 0,
                zIndex: 100,
                color: '#fff'
            }}
        >
            <Space align="center" size={55}>
                <div style={{ display: 'flex', alignItems: 'center', marginRight: 8 }}>
                    <CloudOutlined style={{ fontSize: 22, color: '#e5eaffff' }} />
                </div>
                <span style={{ color: '#fff', fontSize: '18px', fontWeight: '700' }}>{activeLabel}</span>
            </Space>

            <Space size={20} align="center">
                <h4>{date.toLocaleString()}</h4>
                <Link to={"/"}>
                    <Button icon={<HomeOutlined />} />
                </Link>
                <Badge count={3} size="small" offset={[-4, 4]}>
                    <Button type='primary' icon={<BellOutlined style={{ fontSize: 17 }} size={'small'} />} />
                </Badge>
                <Badge count={3} size="small" offset={[-4, 4]}>
                    <Button type='primary' icon={<MessageOutlined style={{ fontSize: 17 }} size={'small'} />} />
                </Badge>

                <Dropdown menu={{ items: userDropdown }} placement="bottomRight" trigger={['click']}>
                    <Space
                        size={10}
                        align="center"
                        style={{
                            cursor: 'pointer',
                            padding: '4px 10px',
                            borderRadius: 8,
                            marginLeft: 4,
                        }}
                    >
                        <Avatar
                            size={30}
                            src={user?.avatar}
                            icon={!user?.avatar && <UserOutlined />}
                            style={{ backgroundColor: '#667eea' }}
                        />
                        <Text strong style={{ fontSize: 13, color: '#fff' }}>
                            {user?.fullname?.split(' ')[0] || user?.phone || 'User'}
                        </Text>
                        <Text type="secondary" style={{ fontSize: 12, color: '#fff' }}>
                            / Provider
                        </Text>
                        <CaretDownOutlined style={{ fontSize: 10, color: '#fff' }} />
                    </Space>
                </Dropdown>
                <Button type='primary' onClick={() => setFullscreen(!fullscreen)}><FullscreenOutlined /></Button>
            </Space>
        </div>
    );
}

export default VendorHeader;